import { Box, Button, CircularProgress, Divider, FormControlLabel, Menu, MenuItem, Radio, RadioGroup, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import { SALE_CONFIG } from './config'
import api from '../../api/api'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faPrint, faSave } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
import './coppyListView.scss'
export default function CoppyListView() {
    const { id } = useParams()
    const [data, setData] = useState([])
    const [PaymentType, setPaymentType] = useState(null)
    const [loadingDownload, setLoadingDownload] = useState(false)
    const { profile, loading } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();

    async function getDoiDetail() {
        const newDoi = encodeURIComponent(id);
        const url = SALE_CONFIG.requests.saleDoi.url + `/${newDoi}`;
        const res = await api.get(url)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setPaymentType(data?.PaymentType)
        }
    }

    useEffect(() => {
        getDoiDetail()
    }, [])
    const CalQtySack = (option2, qty) => {
        let _qty = qty || 0;

        if (option2 === 'หลัก') {
            return Math.ceil(+_qty / 20);
        } else {
            return Math.ceil(+_qty / 25);
        }
    }


    const CalQtyPerSack = (option2, qty) => {
        let _qty = qty || 0;

        if (option2 === 'หลัก') {
            return 20;
        } else {
            return 25;
        }
    }
    const ItemName = (data) => {
        const catalogName = data?.ItemNo?.CatalogNo?.CatalogName;
        const option2 = data?.ItemNo?.Option2;
        const season = data?.ItemNo?.Season;
        const year = data?.Lot?.slice(6, -3);
        const lotNumber = data?.Lot?.slice(8);


        return `${catalogName}/${option2}/${season}/${year}/${lotNumber}`

    }
    function sumPrice(detail) {
        let sum = 0;
        sum = +detail?.SalePrice * detail?.Qty;
        return sum;
    }


    async function downloadFile() {
        setLoadingDownload(true)
        const newDoi = encodeURIComponent(id);
        const res = await api.get(SALE_CONFIG.requests.saleDoi.url + `/${newDoi}/pdf`, {
            responseType: 'arraybuffer'
        })
        const data = res.data

        const blob = new Blob([data], { type: 'application/pdf' });
        // saveAs(blob, file?.FileName);
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingDownload(false)
    }
    async function downloadFileReceipt(mode) {
        setLoadingDownload(true)
        const newDoi = encodeURIComponent(id);
        const res = await api.get(`sale/receipt/${newDoi}/pdf${mode ? `?mode=${mode}` : ''}`, {
            responseType: 'arraybuffer'
        })
        const data = res.data

        const blob = new Blob([data], { type: 'application/pdf' });
        // saveAs(blob, file?.FileName);
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingDownload(false)
    }
    async function CancelDoi() {
        Swal.fire({
            title: 'ยืนยันการยกเลิก',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const convertDoiNo = encodeURIComponent(id)
                const url = SALE_CONFIG.requests.saleDoi.url + `/${convertDoiNo}/cancel`

                const Cancel = async () => {
                    const res = await api.put(url, null)
                    const data = res.data
                    if (data.status === true) {
                        getDoiDetail()
                        Swal.fire(
                            'Good job!',
                            'ยกเลิกเรียบร้อย',
                            'success'
                        )
                    }
                }
                Cancel()

            }

        })
        // this.loading.cancalLoading = false;
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page><div class="container-fluid" >
                <div class="d-flex row align-items-center ">
                    <div class="col-6">
                        <label class="title-content mb-4">
                            ข้อมูล DOI
                        </label>
                        {data?.Status === 'N' &&
                            <label style={{
                                fontSize: '1.5rem',
                                marginLeft: '20px',
                                color: 'red'
                            }}>
                                **ยกเลิก
                            </label>}
                    </div>
                    <div class="col-6 text-end px-4">
                        {data?.Status === 'Y' &&
                            <>
                                <Button
                                    sx={{ width: '150px' }}
                                    startIcon={<FontAwesomeIcon icon={faPrint} />}
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    disabled={loadingDownload ? true : false}
                                    onClick={handleClick} variant='outlined'>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    <MenuItem onClick={() => {
                                        downloadFile()
                                    }}>ดาวน์โหลด Doi</MenuItem>
                                    {data?.Receipt &&
                                    <>
                                    <MenuItem onClick={() => {
                                        downloadFileReceipt()
                                        handleClose()
                                    }}>ดาวน์โหลดใบเสร็จ</MenuItem>
                                    <MenuItem onClick={() => {
                                        downloadFileReceipt(1)
                                        handleClose()
                                    }}>ดาวน์โหลดใบเสร็จ(ตัวจริง)</MenuItem>
                                    <MenuItem onClick={() => {
                                        downloadFileReceipt(2)
                                        handleClose()
                                    }}>ดาวน์โหลดใบเสร็จ(สำเนา)</MenuItem>
                                    </>
                                    }
                                </Menu>
                            </>
                        }

                        {data.Status === 'Y' && profile?.BranchNo?.BranchNo === '00' && <Button onClick={CancelDoi} variant='outlined' color='error' sx={{ marginLeft: '20px' }}>ยกเลิก</Button>}
                    </div>

                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6">
                        <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">
                            {/* ( {saleDois?.CreateDate | date:'dd/MM/yyyy'} ) */}
                            ( {dayjs(data?.CreateDate).format('DD/MM/BBBB')} )

                        </label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField disabled value={data?.CreateId} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">
                            {/* ( {{saleDois?.ModifiedDate | date:'dd/MM/yyyy'}} ) */}
                            ( {dayjs(data?.ModifiedDate).format('DD/MM/BBBB')} )
                        </label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField disabled value={data?.ModifiedId} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">เลขที่ DOI</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.DoiNo} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>

                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.BranchNo?.BranchName} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">วันที่</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={dayjs(data?.DocumentDate).format('DD/MM/BBBB')} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ชื่อผู้ซื้อ</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.DoiDelivery?.ContactName} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ประเภทผู้ซื้อ</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.CustomerTypeNo?.TypeName} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">เบอร์โทรศัพท์</label>


                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.CustomerNo?.Tel} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-md-12">
                        <label class="labelInput">หมายเหตุ</label>

                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                            <TextField value={data?.Remark} variant="standard" fullWidth multiline rows={4}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-md-12">
                        <label class="labelInput">ที่อยู่</label>

                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                            <TextField value={`${data?.DoiDelivery?.HouseNumber ? '' + data?.DoiDelivery?.HouseNumber : ''} ${data?.DoiDelivery?.Moo ? 'หมู่ ' + data?.DoiDelivery?.Moo : ''} ${data?.DoiDelivery?.Address ? '' + data?.DoiDelivery?.Address : ''} ${data?.DoiDelivery?.SubDistrict ? 'ตำบล' + data?.DoiDelivery?.SubDistrict : ''} ${data?.DoiDelivery?.District ? 'อำเภอ' + data?.DoiDelivery?.District : ''} ${data?.DoiDelivery?.Province ? 'จังหวัด' + data?.DoiDelivery?.Province : ''} ${data?.DoiDelivery?.Zipcode}`} variant="standard" fullWidth multiline rows={4}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>

                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <div class="pe-3">ประเภทการขาย :</div>
                    <div class="pe-3">{data?.SaleType}</div>
                </div>
                <div class="d-flex align-items-center">
                    <div class="pe-3">ประเภทการจ่าย :</div>
                    <RadioGroup
                        row
                        value={PaymentType}
                    >
                        <FormControlLabel disabled value="ขายสด" control={<Radio />} label="ขายสด" />
                        <FormControlLabel disabled value="ขายเชื่อ" control={<Radio />} label="ขายเชื่อ" />
                        <FormControlLabel disabled value="จัดทำแปลง" control={<Radio />} label="เพื่อจัดทำแปลงฤดู/ปี" />
                    </RadioGroup>

                    {data?.PaymentType === 'จัดทำแปลง' &&
                        <div style={{ width: '20%' }} >

                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                    }
                </div>
                <div class="coppyListView row pt-5 pb-3">
                    <div class="col-md-12 table-responsive-sm " style={{ height: 'auto' }}>
                        <table class="table table-bordered" style={{ border: '2px' }}>
                            <thead>
                                <tr>
                                    <th scope="col " class="text-center">ลำดับ</th>
                                    <th scope="col " class="text-center">พันธุ์/ชั้นพันธุ์/ฤดู/ปี/ล็อตที่</th>

                                    <th scope="col " class="text-center">จำนวน (ถุง)</th>
                                    <th scope="col " class="text-center">น้ำหนักถุงละ (กิโลกรัม) </th>
                                    <th scope="col " class="text-center">รวมน้ำหนัก (กิโลกรัม) </th>
                                    <th scope="col " class="text-center">ราคากิโลกรัมละ (บาท)</th>

                                    <th scope="col " class="text-center">จำนวนเงิน (บาท)</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {data?.DoiDetails?.map((x, i) => (
                                    <tr >
                                        <td class="text-center">
                                            {i + 1}
                                        </td>
                                        <td class="text-center">
                                            {ItemName(x)}
                                        </td>
                                        <td class="text-center">
                                            {CalQtySack(x?.ItemNo?.Option2, x?.Qty)}
                                        </td>
                                        <td class="text-center">
                                            {CalQtyPerSack(x?.ItemNo?.Option2, x?.Qty)}
                                        </td>
                                        <td class="text-center">
                                            {x?.Qty.toLocaleString()}
                                        </td>
                                        <td class="text-center">
                                            {x?.SalePrice}
                                        </td>
                                        <td class="text-center">
                                            {parseFloat(sumPrice(x)).toFixed(2)
                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                        </td>
                                    </tr>
                                ))}

                                <tr>
                                    <td colspan="6">รวมเป็นเงิน</td>
                                    <td class="text-center">
                                        {parseFloat(data?.SaleTotal).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6">ส่วนลดร้อยละ
                                        {data?.DiscountPercent > 0 ?
                                            data?.DiscountPercent : ''
                                        }
                                    </td>
                                    <td class="text-center">
                                        {parseFloat(data?.DiscountTotal).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6">ค่าขนส่งกิโลกรัมละ 1 บาท</td>
                                    <td class="text-center">
                                        {parseFloat(data?.DeliveryPrice).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6">รวมเป็นเงินสุทธิ</td>
                                    <td class="text-center">
                                        {parseFloat(data?.TotalAmount).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
                {data?.Receipt &&
                    <>
                        <Divider style={{ borderColor: '#000' }} />
                        <label class="title-content mt-4 mb-4">
                            ข้อมูลใบเสร็จ
                        </label>
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">
                                    {/* ( {saleDois?.CreateDate | date:'dd/MM/yyyy'} ) */}
                                    ( {dayjs(data?.Receipt?.CreateDate).format('DD/MM/YYYY')} )

                                </label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField disabled value={data?.Receipt?.CreateId} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">
                                    {/* ( {{saleDois?.ModifiedDate | date:'dd/MM/yyyy'}} ) */}
                                    ( {dayjs(data?.Receipt?.ModifiedDate).format('DD/MM/YYYY')} )
                                </label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField disabled value={data?.Receipt?.ModifiedId} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">เลขที่ใบเสร็จ</label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={data?.Receipt?.ReceiptNo} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>

                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={data?.BranchNo?.BranchName} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">วันที่</label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={dayjs(data?.DocumentDate).format('DD/MM/BBBB')} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">ชื่อผู้ซื้อ</label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={data?.CustomerNo?.ContactName} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">ประเภทผู้ซื้อ</label>

                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={data?.CustomerTypeNo?.TypeName} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">เบอร์โทรศัพท์</label>


                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={data?.CustomerNo?.Tel} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>

                            <div class="col-md-12">
                                <label class="labelInput">ที่อยู่</label>

                                <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                    <TextField value={`${data?.DoiDelivery?.HouseNumber ? 'บ้านเลขที่' + data?.DoiDelivery?.HouseNumber : ''} ${data?.DoiDelivery?.Moo ? 'หมู่ ' + data?.DoiDelivery?.Moo : ''} ${data?.DoiDelivery?.Address ? 'ถนน' + data?.DoiDelivery?.Address : ''} ${data?.DoiDelivery?.SubDistrict ? 'ตำบล' + data?.DoiDelivery?.SubDistrict : ''} ${data?.DoiDelivery?.District ? 'อำเภอ' + data?.DoiDelivery?.District : ''} ${data?.DoiDelivery?.Province ? 'จังหวัด' + data?.DoiDelivery?.Province : ''} ${data?.DoiDelivery?.Zipcode}`} variant="standard" fullWidth multiline rows={4}
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>

                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">จำนวนเงิน</label>


                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={parseFloat(data?.TotalAmount).toFixed(2)
                                        .replace(/\d(?=(\d{3})+\.)/g, "$&,") + ' บาท'}
                                        variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>
                    </>
                }
                <div class="row mt-4">

                    <div class="col-12 ">
                        <Button onClick={() => navigate(-1)} variant='outlined'
                            startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                            sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                    </div>
                </div>
            </div>
            </Page>
        </div>
    )
}
